// Emit only after the real local operation succeeds. No article text in events.
export function emitOnboardingEvent(type, detail = {}) {
  window.dispatchEvent(new CustomEvent('reedle-onboarding-v2', { detail: { type, ...detail } }));
}
